/*==============================================================================
  UPDATE CART QUANTITY
  ==============================================================================*/
function updateCustomizerCartQuantity(groupId, input) {
    var quantityValue = parseInt(input.value);
    var items = {};
    $('.'+groupId+'_qty').each(function(){
        var fixedQuantity = $(this).attr('data-fixed-quantity') && parseInt($(this).attr('data-fixed-quantity'));
        items[$(this).attr('data-line-item-key')] = fixedQuantity ? fixedQuantity : quantityValue;
    });
    updateCustomizerCart(items);
}

/* function removeCustomizerFromCart(groupId) {
    var items = {};
    $('.'+groupId+'_qty').each(function() {
        items[$(this).attr('data-line-item-key')] = 0;
    });
    updateCustomizerCart(items);
}

function updateCustomizerCart(items) {
    $.post(window.Shopify.routes.root + 'cart/update.js', {
        updates: items
    }, function() {
        setTimeout(function () { location.reload(); }, 0);
    });
}
*/

function removeCustomizerFromCart(groupId) {
    var items = {};
    $('.'+groupId+'_qty').each(function() {
        items[$(this).attr('data-line-item-key')] = 0;
    });
    updateCustomizerCart(items);
}

function updateCustomizerCart(items) {
    $.ajax({
      url: window.Shopify.routes.root + 'cart/update.js',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        updates: items
      }),
      type: 'POST',
      dataType: 'html',
      async: true,
      success: function (result) {
        const parser = new URL(window.location);
        parser.searchParams.set('uhash', Math.random()*500000);
        window.location = parser.href;
      }
    });
}